import { IconButton, InputAdornment, useTheme } from '@mui/material';
import { Copy } from '../../copy/Copy';
import { FormInput } from '../FormInput/FormInput';
import Visibility from '@mui/icons-material//Visibility';
import VisibilityOff from '@mui/icons-material//VisibilityOff';
import { useState } from 'react';
import { visibilityBtnSx } from './Password.style';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Password = ({ inputFor, labelText, formik }) => {
  const theme = useTheme();
  const [isShowPassword, setIsShowPassword] = useState(false);

  const handleClickShowPassword = () => setIsShowPassword(!isShowPassword);
  const handleMouseDownPassword = () => setIsShowPassword(!isShowPassword);

  return (
    <FormInput
      inputFor={inputFor ?? 'password'}
      formik={formik}
      labelText={labelText ?? Copy.generate('Inputs.password')}
      inputType={isShowPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {isShowPassword ? (
                <Visibility
                  sx={{ ...visibilityBtnSx(theme), ...tertiaryHoverSx(theme) }}
                />
              ) : (
                <VisibilityOff
                  sx={{ ...visibilityBtnSx(theme), ...tertiaryHoverSx(theme) }}
                />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
